import type { Locale } from 'date-fns'
import type { TFunction } from 'react-i18next'
import { DATE_FORMAT_VARIANTS } from 'redesign/shared/date/constants'
import { formatDateRange } from 'redesign/shared/date/utils'
import type { CmsContentT } from 'types'

export const getEventDateText = ({
  event,
  startDate,
  endDate,
  locale,
  t,
}: {
  event: CmsContentT
  startDate?: string
  endDate?: string
  locale?: Locale
  t: TFunction<'translation', undefined>
}) => {
  if (event.isWholeDay) {
    return t('page.cms.content.event.dateRangeFullDays', {
      dateRange: formatDateRange({
        dateFormat: DATE_FORMAT_VARIANTS.shortWithWeekday,
        dates: { startDate, endDate },
        locale,
        t,
      }),
    })
  }

  return formatDateRange({
    dateFormat: DATE_FORMAT_VARIANTS.shortWithWeekdayAndTime,
    dates: { startDate, endDate },
    locale,
    t,
  })
}
